export default "__VITE_ASSET__yGxDSaXaaBxjtyg20vGvHQ__"